import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { BusinessCharType, IBusinessChar, IBusinessesState } from ".";

export interface IUpgradeBusinessesCharResponse {
    balance: number;
    exp: number;
    businessType: number;
    charType: BusinessCharType;
    char: IBusinessChar;
}

export const upgradeBusinessesChar = createAsyncThunk<IUpgradeBusinessesCharResponse, { businessType: number, char: BusinessCharType }>(
    'upgradeBusinessesChar',
    async ({ businessType, char }) => await api.businesses.upgradeChar(businessType, char)
);

const upgradeBusinessesCharHandler = (builder: ActionReducerMapBuilder<IBusinessesState>) => {
    builder
        .addCase(upgradeBusinessesChar.pending, (state: IBusinessesState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(upgradeBusinessesChar.fulfilled, (state: IBusinessesState, action: PayloadAction<IUpgradeBusinessesCharResponse>) => {
            state.loading = false;

            if (!state.activeBusiness || !action.payload)
                return;

            let listChar, activeChar;
            switch (action.payload.charType) {
                case BusinessCharType.Area:
                    activeChar = state.activeBusiness.area;
                    listChar = state.businesses.find(business => business.type === action.payload.businessType)?.area;
                break;

                case BusinessCharType.Staff:
                    activeChar = state.activeBusiness.staff;
                    listChar = state.businesses.find(business => business.type === action.payload.businessType)?.staff;
                break;
            }
            
            if (activeChar)
                Object.assign(activeChar, action.payload.char);

            if (listChar)
                Object.assign(listChar, action.payload.char);
        })
        .addCase(upgradeBusinessesChar.rejected, (state: IBusinessesState) => {
            state.loading = false;
            state.error = 'Unable to upgrade business char';
        });
};

export default upgradeBusinessesCharHandler;